import { render, staticRenderFns } from "./BoxState.vue?vue&type=template&id=ce9e15f0"
import script from "./BoxState.vue?vue&type=script&lang=js"
export * from "./BoxState.vue?vue&type=script&lang=js"
import style0 from "./BoxState.vue?vue&type=style&index=0&id=ce9e15f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports